angular.module('bribac.entities.subGroupFactory', [])

  .value('subGroupFactory', function subGroupFactory(data) {
    return angular.merge({
      id: null,
      name: null,
      mainGroup: null,
      subjects: [],
      monitors: []
    }, data)
  })
